const ressources = {
    background:{
        large: "../public/assets/img/background-large.jpg",
    }
}



export {
    ressources,

}